"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const systems_1 = require("@/services/systems");
const evaluators_1 = require("@/store/ducks/evaluators");
const buildUsers_1 = require("@/useCases/useCaseUtilities/buildUsers");
function listEvaluatorsGroups(siteId) {
    return (dispatch) => {
        dispatch((0, evaluators_1.getEvaluatorsGroups)());
        (0, systems_1.getSystemsBySiteId)(siteId)
            .then((systems) => {
            const evaluatorsGroup = systems
                .map((system) => {
                const users = system.users;
                return {
                    id: system.id,
                    name: system.name,
                    isLoading: false,
                    evaluators: (0, buildUsers_1.buildUsers)(users, true),
                };
            });
            dispatch((0, evaluators_1.getEvaluatorsGroupsSuccess)(evaluatorsGroup));
        })
            .catch(() => {
            dispatch((0, evaluators_1.getEvaluatorsGroupsError)());
        });
    };
}
exports.default = listEvaluatorsGroups;
